import { Component, inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../../../../store/store.model';
import OFFERS_ACTIONS from '../../../../store/offers/offers.actions';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { OffersType } from '@toevla-webapplications/core';

@Component({
    selector: 'ivva-tabbar',
    templateUrl: './tabbar.component.html',
    styleUrls: ['./tabbar.component.scss'],
    imports: [TranslateModule, AsyncPipe]
})
export class TabbarComponent implements OnInit {
	selectedType$: Observable<OffersType>;

	readonly OffersType = OffersType;

	private store = inject(Store<IvvaStore>);

	ngOnInit() {
		this.selectedType$ = this.store.select('offers', 'type');
	}

	select(type: OffersType) {
		this.store.next(OFFERS_ACTIONS.setType({ t: type }));
	}
}
